import logo from "@/assets/icons/Logo-Hoag.svg";
import Image from "next/image";
import { VariantProps, tv } from "tailwind-variants";

const logoVariants = tv({
  variants: {
    size: {
      sm: "w-12 md:w-16",
      md: "w-24",
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

interface LogoProps extends VariantProps<typeof logoVariants> {}

const Logo: React.FC<LogoProps> = ({ size }) => {
  return (
    <Image alt="Hoag Logo" src={logo} className={logoVariants({ size })} />
  );
};

export default Logo;
